import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-space-between" }

export function render(_ctx, _cache) {
  const _component_v_btn = _resolveComponent("v-btn")
  const _component_GenericPasswordChangeForm = _resolveComponent("GenericPasswordChangeForm")
  const _component_BaseDialog = _resolveComponent("BaseDialog")
  const _component_AuthCard = _resolveComponent("AuthCard")

  return (_openBlock(), _createBlock(_component_AuthCard, null, {
    default: _withCtx(() => [
      _createVNode(_component_GenericPasswordChangeForm, { onSubmit: _ctx.submit }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_btn, {
              type: "submit",
              variant: "flat",
              tile: "",
              color: "primary",
              loading: _ctx.loading
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode(" Change password ", -1)
              ]))]),
              _: 1
            }, 8, ["loading"]),
            _createVNode(_component_v_btn, {
              variant: "text",
              onClick: _ctx.goToLogin
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("Back to login", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"]),
      _createVNode(_component_BaseDialog, {
        label: "Information",
        width: 300,
        modelValue: _ctx.informationDialog,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.informationDialog) = $event))
      }, {
        default: _withCtx(() => [
          _cache[4] || (_cache[4] = _createElementVNode("p", null, "Password successfully changed.", -1)),
          _createVNode(_component_v_btn, {
            color: "primary",
            variant: "flat",
            tile: "",
            onClick: _ctx.goToLogin
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" Back to login ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}